import {Injectable} from '@angular/core';
import {Scene, Color, Object3D} from 'three';
import {ContainerService} from '../../Utils/container.service';

@Injectable({
    providedIn: 'root'
})
export class SceneService {
    public scene: Scene;

    constructor(private containerService: ContainerService) {
    }

    /**
     * initializes scene with white background
     */
    public initScene() {
        this.scene = new Scene();
        this.scene.background = new Color(0xffffff);
    }

    /**
     * adds object to the scene
     */
    public addObject(object: any) {
        this.scene.add(object);
    }

    /**
     * checks if scene contains object with given name
     * @param name
     */
    public sceneContainsName(name: string) {
        let found = false;
        for (const obj of this.scene.children) {
            if (name === obj.name) {
                found = true;
            }
        }
        return found;
    }

    /**
     * adds group with name if it doesn't exist yet
     * @param name: name of group
     */
    public addGroup(name: string) {
        if (!this.sceneContainsName(name)) {
            const group = new Object3D();
            group.name = name;
            this.scene.add(group);
        }
    }

    /**
     * returns group by name
     */
    public getGroupByName(name: string): Object3D {
        return this.scene.getObjectByName(name);
    }

    /**
     * removes group by name
     */
    public removeGroup(name: string) {
        this.scene.remove(this.getGroupByName(name));
    }

    /**
     * (de-)activates image mode
     */
    public enableImageMode(value: boolean) {
        if (value) {
            this.addObject(this.containerService.imagePlane);
            // this.addObject(this.containerService.helpPlane);
        } else {
            this.scene.remove(this.containerService.imagePlane);
            // this.scene.remove(this.containerService.helpPlane);
        }
    }
}
